export enum DateFilterOptions {
  LAST_WEEK = 'LAST_WEEK',
  LAST_FIFTEEN_DAYS = 'LAST_FIFTEEN_DAYS',
  LAST_MONTH = 'LAST_MONTH',
  ALL_SEASON = 'ALL_SEASON',
  CUSTOM_DATE = 'CUSTOM_DATE',
  ALL_PERIOD = 'ALL_PERIOD'
}

export enum StaticPointFieldEnum {
  ALL = 'ALL',
  TRAP = 'TRAP',
  CATALOGUE = 'CATALOGUE',
  PLUVIOMETER = 'PLUVIOMETER'
}

export enum StaticPointType {
  GENERIC = 'GENERIC',
  TRAP = 'TRAP',
  PLUVIOMETER = 'PLUVIOMETER'
}

export enum StaticPointIconType {
  HORMONAL_TRAP = 'HORMONAL_TRAP',
  BUS_STOP = 'BUS_STOP',
  DANGER = 'DANGER',
  CAMERA = 'CAMERA',
  PLUVIOMETER = 'PLUVIOMETER',
  GARAGE = 'GARAGE',
  HQ = 'HQ',
  AIRPORT = 'AIRPORT',
  FLAG = 'FLAG',
  GAS_STATION = 'GAS_STATION',
  LIGHT_TRAP = 'LIGHT_TRAP',
  POLE = 'POLE',
  WARNING = 'WARNING',
  RESTING_AREA = 'RESTING_AREA',
  RENEWABLE_TRAP = 'RENEWABLE_TRAP',
  GATE = 'GATE',
  WEATHER_STATION = 'WEATHER_STATION'
}

export enum StaticPointEventType {
  INSTALL = 'INSTALL',
  UNINSTALL = 'UNINSTALL',
  REINSTALL = 'REINSTALL',
  READ = 'READ',
  RENEWAL = 'RENEWAL',
  DELETE = 'DELETE'
}

export enum SamplingBehavior {
  ACCUMULATIVE = 'ACCUMULATIVE',
  ALWAYSRESET = 'ALWAYSRESET',
  SINGLE_USE = 'SINGLE_USE'
}

export enum ExternalIntegrationSource {
  PROTECTOR = 'PROTECTOR',
  TRAPVIEW = 'TRAPVIEW'
}
